import { render, staticRenderFns } from "./IFSidebar.vue?vue&type=template&id=70995937"
import script from "./IFSidebar.vue?vue&type=script&lang=js"
export * from "./IFSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports